import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Box, TextField, Checkbox } from "@mui/material";
import Divider from "@mui/material/Divider";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import apiinfo from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import _ from "lodash";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import QuestionColumns from "../question/QuestionColumns";
import ErrorAlert from "../../../toolkit/ErrorAlert";

import InputLabel from "@mui/material/InputLabel";
import ListSubheader from "@mui/material/ListSubheader";
import FormControl from "@mui/material/FormControl";
import VariableSizeSelectNested from "../../../utils/VariableSizeSelectNested";

export default function CheckListQuestionDetail() {
  const params = new URLSearchParams(window.location.search);
  const checklistQuestionId = params.get("q");
  const navigate = useNavigate();
  const [questionColumnDetails, setQuestionColumnDetails] = useState([]);
  const [existingQuestions, setExistingQuestions] = useState([]);
  const [details, setDetails] = useState({});
  const [isMandatory, setIsMandatory] = useState(true);
  const [isBold, setIsBold] = useState(false);
  const [isQuestionHidden, setIsQuestionHidden] = useState(false);
  const [hasHighlights, setHasHighlights] = useState(false);
  const [columnCount, setColumnCount] = useState(1);
  const [questionnaireQuestionId, setQuestionnaireQuestionId] = useState(0);
  const [commentPlaceHolder, setCommentPlaceHolder] = useState("");
  const [expectedValue, setExpectedValue] = useState("");
  const [acceptExpectedVal, setAcceptExpectedVal] = useState(true);
  const [acceptPlaceHolder, setAcceptPlaceHolder] = useState(true);
  const [isQuestionLinked, setIsQuestionLinked] = useState(false);
  const [templateQuestions, setTemplateQuestions] = useState([]);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [linkedQuestionColumns, setLinkedQuestionColumns] = useState([]);
  const [columnMapped, setColumnMapped] = useState(null);
  const [mappedColumnError,setMappedColumnError]=useState("")

  const handleTakeExpectedValue = (event) => {
    setAcceptExpectedVal(event.target.checked);
  };

  const handleTakePlaceHolder = (event) => {
    setAcceptPlaceHolder(event.target.checked);
  };
  const [error, setError] = useState(false);
  const [columnMappingError, setColumnMappingError] = useState("");
  const { t } = useTranslation();

  const templateId = params.get("t");
  useEffect(() => {
    getCheckListQuestionDetail();
    getQuestionsByTemplateId();
  }, []);

  const getCheckListQuestionDetail = () => {
    axios
      .get(
        apiinfo.templateTool.GetChecklistQuestionColumnDetail +
          "checklistQuestionId=" +
          checklistQuestionId
      )
      .then((res) => {
        if (res?.data?.status == false) {
          setError(true);
          console.error(res?.data);
          return;
        }
        error && setError(false);
        const _data = res.data.data;
        setDetails(_data);
        if (_data.linkTo > 0) {
          setIsQuestionLinked(true);
        }
        //console.log(_data);
        setColumnCount(_data.numberOfColumns);
        setIsBold(_data.isBold);
        setIsMandatory(_data.isMandatory);
        setIsQuestionHidden(!_data.isVisible);
        setHasHighlights(_data.hasHighlights);
        setQuestionnaireQuestionId(_data.linkTo);
        setExpectedValue(_data.expectedValue);
        setCommentPlaceHolder(_data.commentPlaceholder);
        setAcceptExpectedVal(_data.expectedValue?.length > 0);
        setAcceptPlaceHolder(_data.commentPlaceholder?.length > 0);
        const _checklistQuestionColumnDetails =
          _data.checklistQuestionColumnDetails.map((item, index) => {
            if (!item.questionControlTypeId > 0) {
              return {
                ...item,
                //repeatLogic: true,
              };
            }
            return item;
          });
        setQuestionColumnDetails(_checklistQuestionColumnDetails);
      })
      .catch((err) => {
        setError(true);
        console.error(err);
      });
  };

  const getQuestionsByTemplateId = () => {
    axios
      .get(
        apiinfo.templateTool.GetQuestionsByTemplateId +
          "templateId=" +
          templateId
      )
      .then((res) => {
        if (res?.data?.status == false) {
          setError(true);
          console.error(res?.data);
          return;
        }
        error && setError(false);
        const _data = res.data.data;
        setTemplateQuestions(_data);
        const flattenedData = _data?.flatMap((section) =>
          section.templateSubSections?.flatMap((subSection) =>
            subSection.questions?.map((item) => ({
              groupedName: subSection.subSectionName,
              text: item.questionText,
              value: item.questionID,
            }))
          )
        );

        const noneOption = {
          groupedName: "Select None",
          text: "None",
          value: null,
        };

        setExistingQuestions([noneOption, ...flattenedData]);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const changeColumnCount = (event) => {
    setColumnCount(event.target.value);
  };

  useEffect(() => {
    if (questionnaireQuestionId && questionnaireQuestionId > 0) {
      questionColumnMapping(questionnaireQuestionId);
    } else {
      setShowColumnMapping(false);
      setColumnMappingError("");
    }
  }, [columnCount, templateQuestions, questionnaireQuestionId,isQuestionLinked]);

  const changeColumnMapped = (event) => {
    if(event.target.value){
    setColumnMapped(event.target.value);
    setMappedColumnError("")
    }
  };

  useEffect(() => {
    if (!showColumnMapping) {
      setColumnMapped(0);      
    }
  }, [showColumnMapping]);

  const changeQuestionnaireQuestion = (data) => {
    if (data > 0) {
      setIsQuestionLinked(true);   
      questionColumnMapping(data);  
    } else {
      setIsQuestionLinked(false);
      setQuestionColumnDetails(
        questionColumnDetails.map((item, index) => {
          return {
            ...item,
            questionControlTypeId: 0,
          };
        })
      );
    }
    setQuestionnaireQuestionId(data);
  };

  const questionColumnMapping = (dataId) => {
    debugger   
    const linkedQuestionColumns = templateQuestions.reduce(
      (result, templateQuestion) => {
        const matchingSubSection = templateQuestion.templateSubSections.find(
          (templateSubSection) => {
            const matchingQuestion = templateSubSection.questions.find(
              (question) => question.questionID === dataId
            );
            return matchingQuestion !== undefined;
          }
        );

        if (matchingSubSection) {
          const matchingQuestion = matchingSubSection.questions.find(
            (question) => question.questionID === dataId
          );
          result = matchingQuestion
            ? {
                numberofCols: matchingQuestion.numberOfCols,
                questionColumns: matchingQuestion?.localQuestionColumns,
              }
            : result;
        }

        return result;
      },
      null
    );
    if (
      columnCount != 1 &&
      (linkedQuestionColumns?.numberofCols < columnCount ||
        linkedQuestionColumns?.numberofCols > columnCount)
    ) {
      if (linkedQuestionColumns?.numberofCols > 1){
        setColumnMappingError(
          `Please select either 1 column or match the number of columns with the linked questionnaire (currently ${linkedQuestionColumns?.numberofCols}).`
        );}
      else {setColumnMappingError(`The linked question has 1 column. Please select number of column as 1.`);}
      setShowColumnMapping(false);
    } else if (
      columnCount == 1 &&
      linkedQuestionColumns?.numberofCols > columnCount
    ) {
      setShowColumnMapping(true);
      setColumnMappingError("");
      if (details?.linkTo > 0 && details?.linkTo == questionnaireQuestionId) {      
        let selectedColumn = linkedQuestionColumns?.questionColumns.filter(
          (x) =>
            x.columnNumber ===
            details?.checklistQuestionColumnDetails[0].columnNo
        );
        if(selectedColumn){
          setColumnMapped(selectedColumn[0]?.questionColumnId);   
          setMappedColumnError("");
        }else{
          setMappedColumnError("Please map a column");
        }
         
      }
      else{
        setColumnMapped(null);
        setMappedColumnError("Please map a column");
      }
      const questionColumns = linkedQuestionColumns?.questionColumns?.map(
        (item) => ({
          text: `Column Number: ${item.columnNumber} (Type: ${item.questionControlType})`,
          value: item.questionColumnId,
        })
      );

      setLinkedQuestionColumns([...questionColumns]);
    } else {
      setShowColumnMapping(false);
      setColumnMappingError("");
    }
  };

  const onSubmit = () => {
    const _questionColumnDetails = questionColumnDetails.map((item) => {
      if (item.repeatLogic) {
        return {
          ...item,
          columnNo: item.columnNo,
          checklistQuestionColumnDetailsId:
            item.checklistQuestionColumnDetailsId,
        };
      }
      return item;
    });
    if (!isQuestionLinked) {
      if (
        !_questionColumnDetails.every((item) => item.questionControlTypeId > 0)
      ) {
        const invalidObject = _questionColumnDetails.find(
          (item) => item.questionControlTypeId === 0
        );
        if (invalidObject)
          toastNotify(
            `Please select Input Control Type for Column ${invalidObject.columnNo} `,
            false
          );
        return;
      }

      if (
        _questionColumnDetails.some(
          (item) =>
            item.questionControlTypeId === 12 && !item.buttonTypeReferenceValue
        )
      ) {
        toastNotify(
          `Please fill all required fields`,
          // "The Button Type ReferenceValue field is required.",
          false
        );
        return;
      }

      if (
        _questionColumnDetails.some(
          (item) =>
            [7, 8, 10, 12].includes(item.questionControlTypeId) &&
            (!item.options || item.options.length === 0)
        )
      ) {
        const invalidObject = _questionColumnDetails.find(
          (item) =>
            [7, 8, 10, 12].includes(item.questionControlTypeId) &&
            (!item.options || item.options.length === 0)
        );

        if (invalidObject) {
          toastNotify(
            `Please fill all required fields`,
            // `Value is required field in Column ${invalidObject.columnNo}`,
            false
          );
        }
        return;
      }

      if (
        _questionColumnDetails.some(
          (item) =>
            [9].includes(item.questionControlTypeId) &&
            (!item.options || item.options.length === 0)
        )
      ) {
        const invalidObject = _questionColumnDetails.find(
          (item) =>
            [9].includes(item.questionControlTypeId) &&
            (!item.options || item.options.length === 0)
        );
        if (!invalidObject?.tableReference?.qcTableReference?.length > 0) {
          toastNotify(
            `Please fill all required fields`,
            // `Value is required field in Column ${invalidObject.columnNo}`,
            false
          );
          return;
        }
      }
    }

    let checklistQuestion = {
      checklistQuestionId: details.checklistQuestionId,
      ChecklistQuestionText: details.checklistQuestionText,
      ChecklistSubSectionId: details.checklistSubSectionId,
      Notes: details.notes,
      linkTo: questionnaireQuestionId,
      DisplayOrder: details.displayOrder,
      NumberOfColumns: columnCount,
      IsMandatory: isMandatory,
      IsVisible: !isQuestionHidden,
      IsBold: isBold,
      IsNoteBold: details.isNoteBold,
      QuestionBankId: details.questionBankId,
      HasHighlights: hasHighlights,
      ExpectedValue: acceptExpectedVal ? expectedValue : null,
      CommentPlaceholder: acceptPlaceHolder ? commentPlaceHolder : null,
      checklistQuestionColumnDetails: isQuestionLinked
        ? []
        : _questionColumnDetails,
      mappedColumnId: columnMapped,
    };
    axios
      .post(
        apiinfo.templateTool.AddOrUpdateChecklistQuestion,
        checklistQuestion
      )
      .then((res) => {
        if (res?.data?.responseMessage === "Success") {
          toastNotify("Saved Successfully", true);
          getCheckListQuestionDetail();
        } else {
          toastNotify(res.data.responseMessage, false);
        }
      });
  };

  const handleMandatory = (event) => {
    setIsMandatory(event.target.value === "true");
  };
  const handleIsBold = (event) => {
    setIsBold(event.target.value === "true");
  };
  const handleIsQuestionHidden = (event) => {
    setIsQuestionHidden(event.target.value === "true");
  };
  const handleIsHasHighlights = (event) => {
    setHasHighlights(event.target.value === "true");
  };

  const navigateBack = () => {
    navigate(-1);
  };
  const getItemOrSubheader = (data) => {
    const itemOrSubHeaderList = [];

    itemOrSubHeaderList.push(
      <ListSubheader>{data.subSectionName}</ListSubheader>
    );

    if (data.questions) {
      data.questions.forEach((q, index) => {
        itemOrSubHeaderList.push(
          <MenuItem key={index} value={q.questionID}>
            {q.questionText}
          </MenuItem>
        );
      });
    }
    return itemOrSubHeaderList;
  };
  const handleCommentPlaceholder = (value) => {
    setCommentPlaceHolder(value);
  };
  const handleExpectedValue = (value) => {
    setExpectedValue(value);
  };

  return (
    <>
      <ToastContainer />
      <div
        className="row bg"
        style={{
          minwidth: "100%",
          backgroundColor: "#F9FAFB",
          marginLeft: "auto",
        }}
      >
        <div className="col-sm-12 col-md-3 col-xl-2 block">
          <Typography
            style={{
              textTransform: "capitalize",
              textDecoration: "none",
              color: "rgb(97, 169, 251)",
              cursor: "pointer",
            }}
            onClick={navigateBack}
          >
            {"<-- Back to Checklist"}
          </Typography>
        </div>
        <div className="col-sm-12 col-md-12 col-xl-8">
          {error ? (
            <div className="bg-white rounded p-0">
              <ErrorAlert message={"Error fetching information"} />
            </div>
          ) : (
            <Box sx={{ width: "100%" }}>
              <h1 className="mt-3 d-flex" style={{ color: "rgb(0,0,0)" }}>
                <span>Edit Question's Attribute</span>
                <div className="ms-auto">
                  <Button
                    variant="contained"
                    color="primary"
                    className="primary-button"
                    disabled={columnMappingError || mappedColumnError ? true : false}
                    onClick={onSubmit}
                    style={{ textTransform: "capitalize", padding: "15px" }}
                  >
                    {t("Myinformation.save")}
                  </Button>
                </div>
              </h1>

              <div className="bg-white rounded border p-0 pb-3">
                <label className="personal-info-heading p-1 px-4 border-bottom mx-0 d-flex justify-content-between align-items-center">
                  <b className="my-3">Q. {details.checklistQuestionText}</b>
                  {details.hasUserInput && (
                    <div className="my-1">
                      <ErrorAlert
                        className="border"
                        severity="warning"
                        message={
                          "The response has already been received for the question. Hence limited modifications are allowed."
                        }
                      />
                    </div>
                  )}
                </label>

                <div className="row mt-2 px-3">
                  <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                    <span className="input-label-right">Number Of Columns</span>
                  </div>
                  <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                    <Select
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      value={columnCount}
                      required
                      size="small"
                      placeholder="Department"
                      name="department"
                      id="department"
                      disabled={details.hasUserInput}
                      className="form-control text-feild-custom mx-2 border-0 px-0"
                      onChange={changeColumnCount}
                    >
                      {/* {[...new Array(5)].map((_, index) => (
                    <MenuItem key={index} value={index + 1}>
                        {index + 1}
                    </MenuItem>
                    ))} */}
                      {Array.from({ length: 11 }, (_, index) => (
                        <MenuItem key={index} value={index}>
                          {index}
                        </MenuItem>
                      ))}
                    </Select>
                    {columnMappingError && (
                      <p className="text-danger mx-2">{columnMappingError}</p>
                    )}
                  </div>
                </div>

                <Divider className="mt-3" />

                <div className="row mt-2 px-3">
                  <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                    <span className="input-label-right">Mandatory</span>
                  </div>
                  <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                    <RadioGroup
                      className="mx-2"
                      required
                      row
                      type="radio"
                      value={isMandatory}
                      id="enabledDisabled"
                      name="enabledDisabled"
                      onChange={handleMandatory}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </div>
                <Divider className="mt-3" />

                <div className="row mt-2 px-3">
                  <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                    <span className="input-label-right">Bold</span>
                  </div>
                  <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                    <RadioGroup
                      className="mx-2"
                      required
                      row
                      type="radio"
                      value={isBold}
                      id="isBold"
                      name="isBold"
                      onChange={handleIsBold}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </div>
                <Divider className="mt-3" />

                <div className="row mt-2 px-3">
                  <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                    <span className="input-label-right">Hide Question</span>
                  </div>
                  <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                    <RadioGroup
                      className="mx-2"
                      required
                      row
                      type="radio"
                      value={isQuestionHidden}
                      id="isQuestionHidden"
                      name="isQuestionHidden"
                      onChange={handleIsQuestionHidden}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </div>
                <Divider className="mt-3" />

                <div className="row mt-2 px-3">
                  <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                    <span className="input-label-right">Has Highlights</span>
                  </div>
                  <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                    <RadioGroup
                      className="mx-2"
                      required
                      row
                      type="radio"
                      value={hasHighlights}
                      id="hasHighlights"
                      name="hasHighlights"
                      onChange={handleIsHasHighlights}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="false"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded border p-0 mt-3">
                <div className="row my-2 px-3">
                  <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                    <span className="input-label-right">
                      Link To Questionnaire
                    </span>
                  </div>
                  <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                    <VariableSizeSelectNested
                      options={existingQuestions}
                      isLoading={false}
                      handleChange={changeQuestionnaireQuestion}
                      defaultValue={questionnaireQuestionId}
                      name="Company"
                      isDisabled={details?.hasUserInput ?? false}
                    />
                    {/* <InputLabel htmlFor="grouped-select">Grouping</InputLabel> */}
                    <Select
                      style={{ maxHeight: "400px" }}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                        maxHeight: "400px",
                      }}
                      defaultValue={questionnaireQuestionId}
                      id="grouped-select"
                      className="d-none form-control text-feild-custom mx-2 border-0 px-0"
                      value={questionnaireQuestionId}
                      onChange={changeQuestionnaireQuestion}
                      size="small"
                    ></Select>
                  </div>
                </div>
                {showColumnMapping && (
                  <div className="row mt-2 px-3">
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                      <span className="input-label-right">
                        Please select questionnaire column you want to map
                      </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                      <Select
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        value={columnMapped}
                        required
                        size="small"
                        placeholder="Department"
                        name="department"
                        id="department"
                        disabled={details.hasUserInput}
                        className="form-control border-0 px-0"
                        onChange={changeColumnMapped}
                      >
                        {/* {[...new Array(5)].map((_, index) => (
                    <MenuItem key={index} value={index + 1}>
                        {index + 1}
                    </MenuItem>
                    ))} */}
                        {linkedQuestionColumns?.map((option, index) => (
                          <MenuItem key={index} value={option?.value}>
                            {option?.text}
                          </MenuItem>
                        ))}
                      </Select>
                      {mappedColumnError && (
                      <p className="text-danger">{mappedColumnError}</p>
                    )}
                    </div>
                  </div>
                )}
                {questionnaireQuestionId > 0 && (
                  <div className="row my-2 px-3">
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3">
                      <FormControlLabel
                        className="ms-2"
                        control={
                          <Checkbox
                            disabled={details.hasUserInput}
                            name="isVisible"
                            id="isVisible"
                            inputProps={{ "aria-label": "controlled" }}
                            checked={acceptExpectedVal}
                            onChange={handleTakeExpectedValue}
                          />
                        }
                        label="Expected Value"
                      />
                      {acceptExpectedVal && (
                        <TextField
                          disabled={details.hasUserInput}
                          placeholder="Expected Value Text"
                          value={expectedValue || ""}
                          className="form-control text-feild-custom mx-2 mt-2"
                          onChange={(e) => handleExpectedValue(e.target.value)}
                        />
                      )}
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 mt-3"></div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-3 pb-2 px-0">
                      <FormControlLabel
                        className="ms-2"
                        control={
                          <Checkbox
                            disabled={details.hasUserInput}
                            name="isVisible"
                            id="isVisible"
                            inputProps={{ "aria-label": "controlled" }}
                            checked={acceptPlaceHolder}
                            onChange={handleTakePlaceHolder}
                          />
                        }
                        label="Comment PlaceHolder"
                      />
                      {acceptPlaceHolder && (
                        <TextField
                          disabled={details.hasUserInput}
                          placeholder="Comment Place Holder Text"
                          value={commentPlaceHolder || ""}
                          className="form-control text-feild-custom mx-2 mt-2"
                          onChange={(e) =>
                            handleCommentPlaceholder(e.target.value)
                          }
                        />
                      )}
                    </div>
                  </div>
                )}               
              </div>

              <div
                className={`bg-white rounded border p-0 mt-3 ${
                  isQuestionLinked ? "d-none" : ""
                }`}
              >
                <label className="personal-info-heading p-3 px-4 border-bottom mx-0">
                  <b>Instructions for Input Control atrributes:</b>
                </label>
                <div className="row mt-2 px-3">
                  <div className="col-sm-12 mt-3">
                    <ul>
                      <li>
                        Radio: Enter option values with pipe character(|) as
                        separator in Value text field. E.g. Yes|No|Not
                        Applicable
                      </li>
                      <li>
                        Checkbox: For any string beside checkbox,enter in Value
                        text field. E.g. Is the information correct? or leave it
                        blank.
                      </li>
                      <li>
                        Dropdown: Enter drop down values with pipe character (|)
                        as seperator in Value text field. E.g.
                        Virginia|Florida|Washington|Nebraska|.. etc..
                      </li>
                      <li>
                        Multi Select: Enter drop down values with pipe character
                        (|) as seperator in Value text field. E.g.
                        Plumbing|Electric fittings|Wood Works|Roads and
                        Buildings|.. etc..
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {details?.checklistQuestionId > 0 && !isQuestionLinked && (
                <QuestionColumns
                  questionColumnDetails={questionColumnDetails}
                  details={details}
                  numberOfColumns={columnCount}
                  setQuestionColumnDetails={setQuestionColumnDetails}
                />
              )}
            </Box>
          )}
        </div>
      </div>
    </>
  );
}

const toastNotify = (message, isSuccess = true) => {
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};
